import React from 'react';
import { Grid, Typography, Box, Chip } from '@mui/material';
import minilogo from '../assets/javasite/images/minilogo.png';

const coreStrengths = [
  'Systems Thinking', 'Design Systems', 'User Research & Testing',
  'Cross-Platform UX', 'Prototyping', 'Cross-Functional Collaboration',
  'Agile/Scrum', 'Front-End Development', 'AI-Assisted Design'
];

export function AboutPage() {
  const copyRightDate = new Date().getFullYear();

  return (
    <Grid container justifyContent="center" spacing={1}>
      <Grid item xs={12} md={10} lg={8}>
        <div id="about1" className="isoitem about-tope">
          <div className="blackbox">
            <div id="minilogo"><img src={minilogo} width="196" height="158" alt="DraZtic Mini Logo" /></div>
            <div id="title4"><strong>ABOUT DRAZTIC.COM</strong></div>
            <div id="abouttext" flex="" className="flex">
              <Typography variant="body1" sx={{ mb: 2, color: '#fff' }}>
                Welcome to DraZtic.com. This website was created by myself as a portfolio for my artwork on the web.
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, color: '#fff' }}>
                I'm a UX Designer and Front-End Developer with 15+ years of experience building digital products across web, mobile, and desktop. My background in both design and development gives me a unique ability to bridge the gap between what users need and what engineering can deliver.
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, color: '#fff' }}>
                I've designed and built everything from 30-component design systems to cross-platform biometric applications for healthcare. I care about systems thinking — understanding how pieces connect, not just how individual screens look. And I validate my work through real user research: interviews, prototype testing, and post-launch feedback loops.
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, color: '#fff' }}>
                I'm currently exploring how AI tools like Claude, Copilot, and Deepseek can accelerate the design process — not replace the thinking, but multiply the output. This portfolio is itself a product of that exploration.
              </Typography>

              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ color: '#fff', mb: 1 }}><strong>Core Strengths</strong></Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {coreStrengths.map((skill) => (
                    <Chip key={skill} label={skill} size="small" sx={{ bgcolor: 'rgba(255,255,255,0.1)', color: '#fff' }} />
                  ))}
                </Box>
              </Box>
              <Typography variant="body1" sx={{ mb: 3, color: '#fff' }}>
                Please feel free to look around the site. You will see many retail products and art work offering sales and services. These images, animations, web sites, apps, and graphics were created for clients and business associates for products and/or advertising services.
              </Typography>
<Typography variant="body1" sx={{ mb: 3, color: '#fff' }}>
                These works, while designed by or collaborated on by myself, belong solely to their respective owners and are only being displayed on this site for demonstration/viewing purposes. Note that I have no control or input on the actual content and/or usage of these webpages and/or advertising materials, and the sites themselves aren't affiliated with DraZtic.com.
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, color: '#fff' }}>
                All other (personal) artwork displayed on this site are copyrighted by myself (excluding fan based work). While you may see artwork based on other copyrighted characters (fanart) that I did not create, I myself do all the artwork. These particular works are strickly fan based and no money is made off of them.
              </Typography>
<Typography variant="body1" sx={{ mb: 3, color: '#fff' }}>
                All images (unless stated otherwise) created by DraZtic, Copyright &copy; {copyRightDate}, All rights reserved
                Please do not use images without permission. All non original/fan art characters copyright their respective owners.
              </Typography>
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
